<template>
  <div class="popup_wrap">
    <span class="ticket_btnbox">
      <span class="checkbox">
        <input type="checkbox" id="agree-privacy-checkbox" v-model="inputVal" />
        <label for="agree-privacy-checkbox">한국잡월드 이용약관 동의[필수]</label>
      </span>
      <a class="openPopup" @click="openModal">전문보기</a>
    </span>
    <!-- 레이어팝업 -->
    <modal @close="closeModal" :open="modal.open" title="한국잡월드 이용약관 동의">
      <!-- default 슬롯 콘텐츠 -->
      <div id="koreajobworld_policy">
        <!-- 스크립트 사용 시 모달 크기 오류 발생 -->
        <p style="text-align: center"><span style="font-size: 18px; line-height: 230%">한국잡월드 이용약관</span></p>

        <p><br /></p>

        <p><span style="font-weight: bold">제1조(목적)</span></p>

        <p>
          이 약관은 한국잡월드(이하 “잡월드”라고 한다)의 시설물과 서비스를 이용하는 고객과 잡월드 사이의 거래관계를 명확하게 하고, 고객의 권익 보호를 위해
          필요한 사항을 정하는 것을 목적으로 합니다.
        </p>

        <p><span style="font-weight: bold">제2조(약관의 적용)</span></p>

        <p>&nbsp;&nbsp;① 고객은 이 약관의 내용을 인지하고 잡월드가 정한 시설 및 서비스 이용 규정에 동의한 경우에 체험권을 예약ㆍ구매합니다.</p>

        <p>&nbsp;&nbsp;② 잡월드는 제1항의 고객에 대하여 잡월드의 시설 및 서비스를 제공합니다.</p>

        <p>&nbsp;&nbsp;③ 이 약관에 규정되지 않은 내용에 대해서는 대한민국의 법령 또는 관습에 따릅니다.</p>

        <p>&nbsp;&nbsp;④ 잡월드는 약관을 개정할 수 있으며, 약관을 개정하는 경우에는 제14조에서 정한 바에 따릅니다.</p>

        <p><span style="font-weight: bold">제3조(개장시간 및 입장제한)</span></p>

        <p>
          &nbsp;&nbsp;① 잡월드는 정기휴관일을 제외하고 상시 개장합니다. 다만, 고객에게 서비스를 제공할 수 없는 특별한 사정이 있는 경우에는 폐장할 수 있습니다.
          특별한 사정은 천재지변, 예측할 수 없는 기상재해, 테러의 발생 또는 경보가 있는 경우, 전염병의 발병 또는 확산의 우려가 있는 경우, 그 밖에 잡월드가
          사업장을 운영할 수 없는 합리적인 사유 또는 불가항력이 있는 경우를 말합니다.
        </p>

        <p>
          &nbsp;&nbsp;② 고객에게 서비스를 제공하는 시간은 별도로 게시하여 운영하고, 잡월드의 영업환경에 따라 변경될 수 있습니다. 운영시간이 변경되는 경우에는
          홈페이지, SNS 등을 통하여 고객에게 고지합니다.
        </p>

        <p>
          &nbsp;&nbsp;③ 체험실을 제외한 다른 시설은 고객의 편의와 안전, 시설물의 수용 한도를 고려하여 고객의 입장을 제한할 수 있습니다. 다만, 앞선 고객의 퇴장
          등으로 수용 한도 미만에 이르는 경우 단계적으로 입장 제한 조치를 해제합니다.
        </p>

        <p>
          &nbsp;&nbsp;④ 잡월드는 위험물을 소지한 고객의 입장을 제한할 수 있습니다. 위험물을 소지한 것으로 의심되는 고객에 대하여는 고객의 동의하에 소지품을
          확인할 수 있으며, 고객이 정당한 사유 없이 이를 거부하는 경우에는 잡월드는 고객의 입장을 거부할 수 있습니다.
        </p>

        <p><span style="font-weight: bold">제4조(서비스와 이용요금)</span></p>

        <p>&nbsp;&nbsp;① 잡월드는 체험권을 구매한 고객에게 직업체험 서비스를 제공하고, 무료로 이용 가능한 시설을 이용할 수 있는 서비스를 제공합니다.</p>

        <p>&nbsp;&nbsp;② 잡월드는 체험권과 별도의 유료 시설과 유료 프로그램을 운영할 수 있으며, 해당 사항은 고객에게 별도로 공지합니다.</p>

        <p>&nbsp;&nbsp;③ 잡월드 이용요금은 잡월드 홈페이지 및 안내데스크에 별도로 게시합니다.</p>

        <p>&nbsp;&nbsp;④ 다음 각 호에 해당하는 사람에 대해서는 체험료를 면제합니다.</p>

        <p>&nbsp;&nbsp;1. 「국민기초생활보장법」상의 수급자 및 그 자녀</p>

        <p>&nbsp;&nbsp;2. 15인 이상 단체고객을 인솔하는 사람(고객 15명당 인솔자 1명)</p>

        <p>&nbsp;&nbsp;3. 체험관을 이용함에 있어 반드시 근접 관리가 필요한 장애인의 활동보조인(장애인 1명당 활동보조인 1명)</p>

        <p>&nbsp;&nbsp;⑤ 다음 각 호에 해당하는 고객에 대해서는 체험료의 50%를 할인합니다.</p>

        <p>&nbsp;&nbsp;1. 장애인(「장애인복지법」 제32조에 따른 장애인등록증 소지인)</p>

        <p>&nbsp;&nbsp;2. 국가유공자(「국가유공자 등 예우 및 지원에 관한 법률 시행령」 제101조에 따른 국가유공자증 또는 국가유공자유족증 소지자 및 그 자녀</p>

        <p>&nbsp;&nbsp;3. 만65세 이상자</p>

        <p>&nbsp;&nbsp;⑥ 제4항과 제5항에 따라 체험료를 할인 또는 면제받는 고객은 잡월드 안내데스크에 관련 증빙자료를 제시하여야 합니다.</p>

        <p><span style="font-weight: bold">제5조(예약 및 취소)</span></p>

        <p>&nbsp;&nbsp;① 고객은 잡월드의 체험권 등을 홈페이지 또는 모바일로 방문예정일 1년 전부터 하루 전까지 예약할 수 있습니다.</p>

        <p>&nbsp;&nbsp;② 고객은 예약 후 즉시 결제를 하여야 하며, 단체고객은 결제에 갈음하는 서면을 한국잡월드에 제출하여야 합니다.</p>

        <p>
          &nbsp;&nbsp;③ 고객은 잡월드가 예약고객을 확인하고, 서비스를 원활하게 제공할 수 있도록 방문자 정보(성명, 연락처, 이메일 주소)를 잡월드에 제공하여야
          합니다.
        </p>

        <p>&nbsp;&nbsp;④ 고객은 예약을 완료한 후 예약사항을 확인하여야 하며, 예약내용에 차이가 있는 경우에는 이를 즉시 잡월드에 알려야 합니다.</p>

        <p>
          &nbsp;&nbsp;⑤ 고객은 방문예정일의 체험이 시작되기 전까지 자유롭게 예약을 취소할 수 있으며, 지정한 체험이 시작된 이후에는 예약을 취소할 수 없습니다.
        </p>

        <p><span style="font-weight: bold">제6조(요금의 환불)</span></p>

        <p>
          &nbsp;&nbsp;① 고객이 환불을 요청할 경우 해당 체험이 시작되기 전까지는 전액을 환불하고, 체험이 시작된 이후에는 환불하지 아니합니다. 다만, 다음 각 호의
          사유가 있는 경우에는 체험이 시작된 이후에도 환불할 수 있습니다.
        </p>

        <p>&nbsp;&nbsp;1. 4촌 이내 친족의 사망</p>

        <p>&nbsp;&nbsp;2. 법정 전염병</p>

        <p>&nbsp;&nbsp;3. 잡월드 시설의 이용이 불가능한 질병 및 부상</p>

        <p>&nbsp;&nbsp;4. 강우, 강설 등 천재지변으로 교통수단을 이용하는 것이 불가능하거나, 교육 관련 관서에서 휴교령 등의 이동제한 조치가 있는 경우</p>

        <p>&nbsp;&nbsp;5. 그 밖에 잡월드의 귀책 사유로 체험을 하지 못한 경우</p>

        <p>&nbsp;&nbsp;② 고객의 환불 요청이 있는 경우 잡월드는 요청을 받은 날로부터 7일 이내에 다음 각 호의 방법으로 환불합니다.</p>

        <p>&nbsp;&nbsp;1. 당일 현금결제의 경우는 현금 환불</p>

        <p>&nbsp;&nbsp;2. 카드 결제의 경우에는 승인 취소</p>

        <p>&nbsp;&nbsp;3. 계좌이체, 무통장입금의 경우에는 고객이 지정하는 계좌에 입금</p>

        <p>
          &nbsp;&nbsp;③ 제1항 제1호부터 3호의 경우에 고객은 그 사실을 증빙할 수 있는 서류를 체험일 포함 3일 이내에 제출하여야 합니다. 고객이 증빙서류를 제출하지
          않는 경우에는 환불이 불가합니다.
        </p>

        <p><span style="font-weight: bold">제7조(고객의 의무)</span></p>

        <p>
          &nbsp;&nbsp;① 고객은 관계 법령, 이 약관의 규정과 이용 안내 및 주의사항 등 잡월드가 통지하는 사항을 준수하여야 하며, 그 밖에 잡월드의 업무에 방해되는
          행위를 해서는 안 됩니다.
        </p>

        <p>&nbsp;&nbsp;② 고객은 잡월드의 사전 동의 없이 잡월드가 제공하는 서비스 등을 이용하여 영리 행위를 해서는 안 됩니다.</p>

        <p>
          &nbsp;&nbsp;③ 고객은 서비스 등을 이용하여 얻은 정보를 잡월드의 사전 동의 없이 복사, 복제, 변경, 번역, 출판, 방송 그 밖의 방법으로 사용하거나 이를
          타인에게 제공하여서는 안 됩니다.
        </p>

        <p>&nbsp;&nbsp;④ 고객은 서비스 이용과 관련하여 다음 각 호의 행위를 해서는 안 됩니다.</p>

        <p>&nbsp;&nbsp;1. 다른 고객의 아이디(ID)를 부정 사용하는 행위</p>

        <p>&nbsp;&nbsp;2. 범죄를 목적으로 하거나 그 밖에 범죄행위와 관련된 행위</p>

        <p>&nbsp;&nbsp;3. 다른 사람의 명예를 훼손하거나 모욕하는 행위</p>

        <p>&nbsp;&nbsp;4. 서비스의 안정적인 운영에 지장을 주거나 줄 우려가 있는 행위</p>

        <p>&nbsp;&nbsp;5. 그 밖에 관계 법령에 위배되는 행위</p>

        <p>
          &nbsp;&nbsp;⑤ 제4조 제4항 및 제5항에 따라 체험료를 면제ㆍ할인받은 고객은 잡월드의 승인 없이 체험권을 제3자에게 양도해서는 안 됩니다. 해당 체험권을
          잡월드의 승인 없이 양도한 사실이 확인되는 경우에는 확인된 날부터 3년간 잡월드의 체험료를 면제 또는 할인받을 자격이 박탈될 수 있습니다.
        </p>

        <p>
          &nbsp;&nbsp;⑥ 제4조 제4항에 따라 체험료를 면제받은 고객이 예정한 날에 서비스를 이용하지 못하게 될 경우에는 체험이 시작되기 전에 예약을 취소하여야
          합니다. 체험료를 면제받는 고객이 연속하여 3회 이상 예약을 취소하지 않고 서비스를 이용하지 않는 경우에 잡월드는 예약 건에 대하여 이용 의사를 확인할 수
          있고, 고객의 이용 의사가 없는 경우에는 해당 예약을 취소할 수 있습니다. 잡월드가 이용 의사를 확인할 때 허위로 이용 의사를 표시한 경우에는 잡월드가
          직권으로 예약을 취소할 수 있습니다.
        </p>

        <p><span style="font-weight: bold">제8조(이용수칙)</span></p>

        <p>
          &nbsp;&nbsp;고객은 고객의 안전과 원활하고 쾌적한 서비스의 이용을 위하여 다음 각 호의 행위를 해서는 안 됩니다. 다만, 제7호의 경우에 잡월드의 사전
          승인을 받은 경우에는 그러하지 아니합니다.
        </p>

        <p>&nbsp;&nbsp;1. 다른 사람에게 혐오감을 유발하거나 잡월드의 영업에 방해를 줄 수 있는 물품을 반입하거나 사용하는 행위</p>

        <p>&nbsp;&nbsp;2. 맹인 안내견을 제외한 반려동물을 데리고 입장하는 행위</p>

        <p>&nbsp;&nbsp;3. 다른 사람에게 혐오감을 주는 복장이나 고성방가, 폭력행사 등 잡월드 이용 중 다른 사람에게 해가 될 우려가 있는 행위</p>

        <p>&nbsp;&nbsp;4. 잡월드 내에서의 흡연 및 음주 행위</p>

        <p>&nbsp;&nbsp;5. 체험시설에 입장할 때 식음료를 지참하는 행위</p>

        <p>&nbsp;&nbsp;6. 다른 사람의 초상권 등 정당한 권리를 침해할 수 있는 사진이나 동영상을 촬영‧유포하는 행위</p>

        <p>&nbsp;&nbsp;7. 잡월드 내에서 촬영이 금지된 체험실 등에서 사진이나 동영상을 촬영‧유포하는 행위</p>

        <p>&nbsp;&nbsp;8. 그 밖에 잡월드의 운영을 방해하는 일체의 행위</p>

        <p><span style="font-weight: bold">제9조(시설물 이용 제한)</span></p>

        <p>&nbsp;&nbsp;① 잡월드는 고객의 안전을 위하여 나이, 신장, 건강 상태 등의 신체 조건을 고려하여 특정한 시설물의 이용을 제한할 수 있습니다.</p>

        <p>&nbsp;&nbsp;② 잡월드는 영업시간 중 안전을 위하여 시설물을 점검할 필요가 있는 경우 해당 시설물의 이용을 일시적으로 중단할 수 있습니다.</p>

        <p>&nbsp;&nbsp;③ 각 시설물의 이용에 관한 안내와 주의사항은 별도로 게시합니다.</p>

        <p><span style="font-weight: bold">제10조(미아보호)</span></p>

        <p>&nbsp;&nbsp;① 잡월드는 미아보호소를 운영하며 미아를 보호자에게 인계하기 위한 제반 조치를 취합니다.</p>

        <p>&nbsp;&nbsp;② 잡월드는 미아 발생 대장을 기록, 유지하며, 미아를 보호자에게 인계할 경우에는 보호자임을 확인한 후 인계합니다.</p>

        <p>&nbsp;&nbsp;③ 당일에 인계하지 못한 미아에 대해서는 미아 발생기록과 함께 관할 경찰서에 인계합니다.</p>

        <p><span style="font-weight: bold">제11조(유실물 처리)</span></p>

        <p>&nbsp;&nbsp;① 잡월드는 습득한 유실물 보관소를 운영하며, 물품 인계를 위한 제반 조치를 취합니다.</p>

        <p>
          &nbsp;&nbsp;② 잡월드는 습득한 물건 중 귀중품, 신분증, 카드류, 전기ㆍ전자제품은 한 달 동안 보관하며, 그 기간이 경과한 경우에는 경찰청 유실물
          종합관리시스템에 접수한 후 분당경찰서로 이관하며, 그 밖의 물건은 6개월간 보관한 후 아름다운 가게에 기증합니다.
        </p>

        <p>&nbsp;&nbsp;③ 잡월드가 습득한 물건 중 부패되기 쉬운 음식물 등 보관이 용이하지 않은 물건은 습득한 다음 날이 지나면 폐기합니다.</p>

        <p>
          &nbsp;&nbsp;④
          <span style="letter-spacing: -5%">그 밖에 유실물 처리에 관한 상세사항은 유실물법의 규정에 따릅니다.</span>
        </p>

        <p><span style="font-weight: bold">제12조(잡월드의 배상책임)</span></p>

        <p>
          &nbsp;&nbsp;① 잡월드는 시설 운영 중 잡월드의 지휘ㆍ감독을 받는 직원의 고의ㆍ과실 또는 잡월드가 유지ㆍ보수ㆍ관리 책임을 지는 시설의 하자로 인하여
          고객에게 사고가 발생한 경우 이에 대한 책임을 부담합니다.
        </p>

        <p>
          &nbsp;&nbsp;② 제1항의 사고로 인하여 고객에게 신체상 또는 재산상 피해가 발생한 경우 잡월드는 그 손해를 배상합니다. 다만, 그 손해가 불가항력으로 인하여
          발생한 경우 또는 그 손해의 발생이 고객의 고의 또는 과실에 의한 경우에는 그 배상책임이 경감 또는 면제됩니다.
        </p>

        <p>&nbsp;&nbsp;③ 잡월드는 배상책임을 이행하기 위하여 책임보험에 가입합니다.</p>

        <p><span style="font-weight: bold">제13조(고객의 책임)</span></p>

        <p>&nbsp;&nbsp;① 고객이 고의 또는 과실로 잡월드의 시설물과 비품을 훼손한 경우에는 그 손해를 배상하여야 합니다.</p>

        <p>&nbsp;&nbsp;② 고객의 고의 또는 과실로 다른 고객, 잡월드의 직원 등 제3자에게 손해를 입힌 경우 고객은 이에 대해 책임을 부담합니다.</p>

        <p><span style="font-weight: bold">제14조(약관의 변경 및 분쟁 조정)</span></p>

        <p>
          &nbsp;&nbsp;① 이 약관의 내용은 잡월드의 영업환경 변화 등에 따라 변경될 수 있으며, 잡월드가 약관을 개정하는 경우에는 적용예정일 및 개정 사유 등을 다음
          각 호의 방법 중 1가지 이상의 방법으로 고지합니다.
        </p>

        <p>&nbsp;&nbsp;1. e-mail.통보</p>

        <p>&nbsp;&nbsp;2. 서면통보</p>

        <p>&nbsp;&nbsp;3. 인터넷 홈페이지 게시</p>

        <p>&nbsp;&nbsp;4. SMS</p>

        <p>
          &nbsp;&nbsp;② 고객에게 불리하게 약관 내용을 변경하는 경우에는 최소 30일 이상의 유예기간을 두고 공지합니다. 이 경우 개정 전ㆍ후 내용을 명확하게
          비교하여 알기 쉽게 표시합니다.
        </p>

        <p>&nbsp;&nbsp;③ 이 약관과 관련된 분쟁이 발생하는 경우에는 민사소송법의 관할 규정에 따릅니다.</p>

        <p><br /></p>

        <p><br /></p>

        <p>[부칙]&nbsp;</p>

        <p>
          1.
          <span style="font-size: 14px; line-height: 230%">본 약관은 2022년 11월 1일부터 시행됩니다.</span>
        </p>
      </div>
      <!-- /default -->
      <!-- footer 슬롯 콘텐츠 -->
      <template slot="footer">
        <div class="btn_wrap tcen">
          <a class="wdhalf btn btn_bg gray" @click="() => onButtonClick(false)">비동의</a>
          <a class="wdhalf btn btn_bg color" @click="() => onButtonClick(true)">동의</a>
        </div>
        <!-- <button @click="selectPcnt">확인</button>
        <button @click="closeModal">취소</button> -->
      </template>
      <!-- /footer -->
    </modal>
  </div>
</template>

<script>
import Modal from '@/components/common/Modal.vue';
export default {
  components: { Modal },
  props: ['value'],
  data() {
    return {
      modal: {
        open: false,
      },
    };
  },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  watch: {},
  methods: {
    openModal() {
      this.modal.open = true;
    },
    closeModal() {
      this.modal.open = false;
    },
    onButtonClick(agree) {
      this.$emit('input', agree);
      this.closeModal();
    },
  },
};
</script>

<style lang="scss" scoped>
.popup_wrap {
  display: inline-block;
  & a {
    cursor: pointer;
  }
  & .checkbox input[type='checkbox'] + label {
    font-size: 16px;
    display: inline-block;
    height: 19px;
    padding-left: 23px;
    line-height: 19px;
    background-size: 19px 19px;
    width: initial;
  }
}
</style>
